import { render, staticRenderFns } from "./longhorn.vue?vue&type=template&id=947a72b8&"
import script from "./longhorn.vue?vue&type=script&lang=js&"
export * from "./longhorn.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports